import { Translation } from "./common";

export interface ScheduledNotificationsRequest {
  is_canceled?: boolean;
  is_sent?: boolean;
  planned_dt_from?: string;
  planned_dt_to?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

export interface CreateScheduledNotificationRequest {
  plannedDt?: string;
  userIds: string[];
  translations: Translation[];
}

export interface UpdateScheduledNotificationRequest {
  plannedDt?: string;
  userIds?: string[];
  translations?: Translation[];
}

export interface DeleteScheduledNotificationsRequest {
  uuids: string[];
}

export interface ScheduledNotificationResponse {
  id: string;
  createdAt: string;
  plannedDt: string;
  sentAt: string | null;
  canceledAt: string | null;
  userIds: string[];
  translations: Translation[];
}

export enum NotificationStatus {
  SCHEDULED = "SCHEDULED", // Запланированные
  SENT = "SENT", // Отправленные
  CANCELED = "CANCELED", // Отмененные
  EXPIRED = "EXPIRED", // Просроченные
}

// Метод для получения статуса по модели
export function getNotificationStatus(
  notification: ScheduledNotificationResponse
): NotificationStatus {
  if (notification.canceledAt) {
    return NotificationStatus.CANCELED;
  }

  if (notification.sentAt) {
    return NotificationStatus.SENT;
  }

  const plannedDate = new Date(notification.plannedDt);
  const now = new Date();

  if (plannedDate < now) {
    return NotificationStatus.EXPIRED;
  }

  return NotificationStatus.SCHEDULED;
}

export type NotificationsTabsType = "all" | "scheduled" | "sended";
